import React from 'react'
import MainBlog from "../../Components/Blog/Blog"
import Scroll from "../../Components/ScrollToTop"


function Blog() {
  return (
    <div>
      <Scroll/>
      <MainBlog/>
      
    
    </div>
  )
}

export default Blog

